const constant = {
  gong_neng_list: [
    [
      {
        key: '客户',
        val: '',
        icon: 'icon-customer',
        url: '/new/customer/user',
        disabled: false
      },
      {
        key: '核算单',
        val: '',
        icon: 'icon-hesuandan',
        url: '/new/verify/list',
        disabled: false
      },
      {
        key: '订单',
        val: '',
        icon: 'icon-dingdan',
        url: '/new/order/list',
        disabled: false
      },
      {
        key: '工程协同',
        val: '',
        icon: 'icon-gongcheng',
        url: '/new/gongcheng/list',
        disabled: false
      },
      {
        key: '工序',
        val: '',
        icon: 'icon-gongxu',
        url: '/new/gongxu/list',
        disabled: false
      },
      {
        key: '工艺',
        val: '',
        icon: 'icon-gongyi',
        url: '/new/gongyi/list',
        disabled: false
      },
      {
        key: '生产班组',
        val: '',
        icon: 'icon-banzu',
        url: '/new/banzu/list',
        disabled: false
      },
      {
        key: '设备',
        val: '',
        icon: 'icon-shebei',
        url: '/production/she-bei/list',
        disabled: false
      },
      {
        key: 'PMC订单',
        val: '',
        icon: 'icon-pmcdingdan',
        url: '/new/pmc/list',
        disabled: false
      },
      {
        key: '采购申请单',
        val: '',
        icon: 'icon-caigoushenqingdan',
        url: '/new/purchase/apply/list',
        disabled: false
      },
      {
        key: '生产任务',
        val: '',
        icon: 'icon-dingdanpaichan',
        url: '/new/renwu/list',
        disabled: false
      },
      {
        key: '委外加工',
        val: '',
        icon: 'icon-waixiejiagong',
        url: '/new/weiwai/list',
        disabled: false
      },
      {
        key: '送货单',
        val: '',
        icon: 'icon-songhuodan-',
        url: '/new/delivery/list',
        disabled: false
      },
      {
        key: '收款单',
        val: '',
        icon: 'icon-shoukuandan',
        disabled: true
      },
      {
        key: '物流单',
        val: '',
        icon: 'icon-wuliudanhao',
        disabled: true
      },
      {
        key: '销售退货单',
        val: '',
        icon: 'icon-a-jinhuotuihuodanxiaoshoutuihuodan',
        disabled: true
      },
      {
        key: '标签打印',
        val: '',
        icon: 'icon-biaoqiandayinx',
        disabled: true
      },
      {
        key: '客户对账单',
        val: '',
        icon: 'icon-kehuduizhangdan',
        disabled: true
      },
      {
        key: '销售发票',
        val: '',
        icon: 'icon-xiaoshoufapiao',
        disabled: true
      },
      {
        key: '订单结算',
        val: '',
        icon: 'icon-dingdanjiesuan',
        disabled: true
      }
    ],
    [
      {
        key: '请假',
        val: '',
        icon: 'icon-qingjiadan',
        disabled: true
      },
      {
        key: '出差',
        val: '',
        icon: 'icon-chucha',
        disabled: true
      },
      {
        key: '报销单',
        val: '',
        icon: 'icon-baoxiaodan',
        disabled: true
      }
    ]
  ],
  ye_wu_list: [
    [
      {
        key: '客户列表',
        val: '',
        count: '',
        url: '/new/customer/user',
        disabled: false
      },
      {
        key: '客户成本列表',
        val: '',
        count: '',
        url: '/new/customer/cost',
        disabled: false
      },
      {
        key: '客户分析表',
        val: '',
        count: '',
        url: '/new/customer/analyze',
        disabled: false
      },
      {
        key: '待接待客户',
        val: '',
        count: '',
        url: '/new/customer/user?status=待接待',
        disabled: false,
        isRed: true
      },
      {
        key: '已成交客户',
        val: '',
        count: '',
        url: '/new/customer/user?type=已成交客户',
        disabled: false
      },
      {
        key: '未成交客户',
        val: '',
        count: '',
        url: '/new/customer/user?type=未成交客户',
        disabled: false
      },
      {
        key: '10天没跟进客户',
        val: '',
        count: '',
        url: '/new/customer/user?type=10天没跟进客户',
        disabled: false
      },
      {
        key: '20天没跟进客户',
        val: '',
        count: '',
        url: '/new/customer/user?type=20天没跟进客户',
        disabled: false
      },
      {
        key: '30天没跟进客户',
        val: '',
        count: '',
        url: '/new/customer/user?type=30天没跟进客户',
        disabled: false
      }
    ],
    [
      {
        key: '核算单列表',
        val: '',
        count: '',
        url: '/new/verify/list',
        disabled: false
      },
      {
        key: '暂存',
        val: '',
        count: '',
        url: '/new/verify/list?status=暂存',
        disabled: false
      },
      {
        key: '已驳回',
        val: '',
        count: '',
        url: '/new/verify/list?status=已驳回',
        disabled: false
      }
    ],
    [
      {
        key: '订单列表',
        val: '',
        count: '',
        url: '/new/order/list',
        disabled: false
      },
      {
        key: '待审核',
        val: '',
        count: '',
        url: '/new/order/list?status=待审核',
        disabled: false,
        isRed: true
      },
      {
        key: '进行中',
        val: '',
        count: '',
        url: '/new/order/list?status=进行中',
        disabled: false
      },
      {
        key: '已完结',
        val: '',
        count: '',
        url: '/new/order/list?status=已完结',
        disabled: false
      },
      {
        key: '已作废',
        val: '',
        count: '',
        url: '/new/order/list?status=已作废',
        disabled: false
      }
    ],
    [
      {
        key: '工程协同列表',
        val: '',
        count: '',
        url: '/new/gongcheng/list',
        disabled: false
      }
    ],
    [
      {
        key: '工序列表',
        val: '',
        count: '',
        url: '/new/gongxu/list',
        disabled: false
      }
    ],
    [
      {
        key: '工艺列表',
        val: '',
        count: '',
        url: '/new/gongyi/list',
        disabled: false
      }
    ],
    [
      {
        key: '生产班组列表',
        val: '',
        count: '',
        url: '/new/banzu/list',
        disabled: false
      }
    ],
    [
      {
        key: '设备列表',
        val: '',
        count: '',
        url: '/production/she-bei/list',
        disabled: false
      }
    ],
    [
      {
        key: 'PMC订单列表',
        val: '',
        count: '',
        url: '/new/pmc/list',
        disabled: false
      }
    ],
    [
      {
        key: '采购申请列表',
        val: '',
        count: '',
        url: '/new/purchase/apply/list',
        disabled: false
      }
    ],
    [
      {
        key: '生产任务列表',
        val: '',
        count: '',
        url: '/new/renwu/list',
        disabled: false
      },
      {
        key: 'xxx',
        val: '',
        count: '',
        disabled: true
      },
      {
        key: 'xxx',
        val: '',
        count: '',
        disabled: true
      },
      {
        key: 'xxx',
        val: '',
        count: '',
        disabled: true
      },
      {
        key: 'xxx',
        val: '',
        count: '',
        disabled: true
      }
    ],
    [
      {
        key: '委外加工列表',
        val: '',
        count: '',
        url: '/new/weiwai/list',
        disabled: false
      },
      {
        key: 'xxx',
        val: '',
        count: '',
        disabled: true
      },
      {
        key: 'xxx',
        val: '',
        count: '',
        disabled: true
      },
      {
        key: 'xxx',
        val: '',
        count: '',
        disabled: true
      },
      {
        key: 'xxx',
        val: '',
        count: '',
        disabled: true
      }
    ],
    [
      {
        key: '送货单列表',
        val: '',
        count: '',
        url: '/new/delivery/list',
        disabled: false
      },
      {
        key: 'xxx',
        val: '',
        count: '',
        disabled: true
      },
      {
        key: 'xxx',
        val: '',
        count: '',
        disabled: true
      },
      {
        key: 'xxx',
        val: '',
        count: '',
        disabled: true
      },
      {
        key: 'xxx',
        val: '',
        count: '',
        disabled: true
      }
    ],
    [
      {
        key: '收款单列表',
        val: '',
        count: '',
        disabled: true
      },
      {
        key: '待审核',
        val: '',
        count: '',
        disabled: true
      },
      {
        key: '已通过',
        val: '',
        count: '',
        disabled: true
      },
      {
        key: '已驳回',
        val: '',
        count: '',
        disabled: true
      },
      {
        key: '已取消',
        val: '',
        count: '',
        disabled: true
      }
    ],
    [
      {
        key: '物流单列表',
        val: '',
        count: '',
        disabled: true
      },
      {
        key: 'xxx',
        val: '',
        count: '',
        disabled: true
      },
      {
        key: 'xxx',
        val: '',
        count: '',
        disabled: true
      },
      {
        key: 'xxx',
        val: '',
        count: '',
        disabled: true
      },
      {
        key: 'xxx',
        val: '',
        count: '',
        disabled: true
      }
    ],
    [
      {
        key: '销售退货单列表',
        val: '',
        count: '',
        disabled: true
      },
      {
        key: 'xxx',
        val: '',
        count: '',
        disabled: true
      },
      {
        key: 'xxx',
        val: '',
        count: '',
        disabled: true
      },
      {
        key: 'xxx',
        val: '',
        count: '',
        disabled: true
      },
      {
        key: 'xxx',
        val: '',
        count: '',
        disabled: true
      }
    ],
    [
      {
        key: '标签打印列表',
        val: '',
        count: '',
        disabled: true
      },
      {
        key: 'xxx',
        val: '',
        count: '',
        disabled: true
      },
      {
        key: 'xxx',
        val: '',
        count: '',
        disabled: true
      },
      {
        key: 'xxx',
        val: '',
        count: '',
        disabled: true
      },
      {
        key: 'xxx',
        val: '',
        count: '',
        disabled: true
      }
    ],
    [
      {
        key: '客户对账单列表',
        val: '',
        count: '',
        disabled: true
      },
      {
        key: 'xxx',
        val: '',
        count: '',
        disabled: true
      },
      {
        key: 'xxx',
        val: '',
        count: '',
        disabled: true
      },
      {
        key: 'xxx',
        val: '',
        count: '',
        disabled: true
      },
      {
        key: 'xxx',
        val: '',
        count: '',
        disabled: true
      }
    ],
    [
      {
        key: '销售发票列表',
        val: '',
        count: '',
        disabled: true
      },
      {
        key: 'xxx',
        val: '',
        count: '',
        disabled: true
      },
      {
        key: 'xxx',
        val: '',
        count: '',
        disabled: true
      },
      {
        key: 'xxx',
        val: '',
        count: '',
        disabled: true
      },
      {
        key: 'xxx',
        val: '',
        count: '',
        disabled: true
      }
    ],
    [
      {
        key: '订单结算列表',
        val: '',
        count: '',
        disabled: true
      },
      {
        key: 'xxx',
        val: '',
        count: '',
        disabled: true
      },
      {
        key: 'xxx',
        val: '',
        count: '',
        disabled: true
      },
      {
        key: 'xxx',
        val: '',
        count: '',
        disabled: true
      },
      {
        key: 'xxx',
        val: '',
        count: '',
        disabled: true
      }
    ],
    [
      {
        key: '请假列表',
        val: '',
        count: '',
        disabled: true
      },
      {
        key: 'xxx',
        val: '',
        count: '',
        disabled: true
      },
      {
        key: 'xxx',
        val: '',
        count: '',
        disabled: true
      },
      {
        key: 'xxx',
        val: '',
        count: '',
        disabled: true
      },
      {
        key: 'xxx',
        val: '',
        count: '',
        disabled: true
      }
    ],
    [
      {
        key: '出差列表',
        val: '',
        count: '',
        disabled: true
      },
      {
        key: 'xxx',
        val: '',
        count: '',
        disabled: true
      },
      {
        key: 'xxx',
        val: '',
        count: '',
        disabled: true
      },
      {
        key: 'xxx',
        val: '',
        count: '',
        disabled: true
      },
      {
        key: 'xxx',
        val: '',
        count: '',
        disabled: true
      }
    ],
    [
      {
        key: '报销列表',
        val: '',
        count: '',
        disabled: true
      },
      {
        key: 'xxx',
        val: '',
        count: '',
        disabled: true
      },
      {
        key: 'xxx',
        val: '',
        count: '',
        disabled: true
      },
      {
        key: 'xxx',
        val: '',
        count: '',
        disabled: true
      },
      {
        key: 'xxx',
        val: '',
        count: '',
        disabled: true
      }
    ]
  ]
}

export default constant
